export default __webpack_public_path__ + "static/media/social-media-arrow.ecc0133c.svg";